export var menu = [
  {
    name: "Idli",
    description:
      "South Indian Savory Rice Cake. Served with Chutneys. Steamed. Popular. Breakfast.",
    pic_url:
      "https://images.unsplash.com/photo-1589301760014-d929f3979dbc?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    inventory: "100",
    price: "20",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Thali",
    description: "",
    pic_url: "https://www.nagarjunarestaurants.com/images/thestory.jpg",
    inventory: 20,
    price: "100",
    tags: ["thali", "lunch", "south-indian", "meals"],
  },
  {
    name: "Sambar Idli",
    description: "",
    pic_url:
      "https://cookingfromheart.com/wp-content/uploads/2019/02/Ghee-Sambar-Idli-1.jpg",
    inventory: 20,
    price: "30",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Vada",
    description: "",
    pic_url:
      "https://media.istockphoto.com/id/1292633263/photo/indian-fried-snack-medu-vada-with-sambar-and-coconut-chutney-in-plate-on-rustic-wooden.jpg?s=612x612&w=0&k=20&c=I24Sl76Qq4ly7WlI3HJJa8VfCIkBxvsgVZ8mAb81ZEA=",
    inventory: 20,
    price: "20",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "White Upma",
    description: "",
    pic_url:
      "https://www.healthifyme.com/blog/wp-content/uploads/2023/05/shutterstock_1904780038-1.jpg",
    inventory: 20,
    price: "30",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Yellow Upma",
    description: "",
    pic_url:
      "https://pipingpotcurry.com/wp-content/uploads/2018/01/Rava-Upma-Instant-Pot-Pressure-Cooker.jpg",
    inventory: 20,
    price: "30",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Uttapam",
    description: "",
    pic_url:
      "https://t3.ftcdn.net/jpg/03/97/46/76/360_F_397467628_x7D5LqWNQxWHzSOjoBffP4mnYr0mRTEF.jpg",
    inventory: 20,
    price: "20",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Mysore Bonda",
    description: "",
    pic_url:
      "https://media-assets.swiggy.com/swiggy/image/upload/f_auto,q_auto,fl_lossy/g8xw7fb9pkhmyzedbjzo",
    inventory: 20,
    price: "30",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Ravva Idli",
    description: "",
    pic_url:
      "https://www.sailusfood.com/wp-content/uploads/2017/03/wheat-rava-idli-recipe.jpg",
    inventory: 20,
    price: "30",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Poori",
    description: "",
    pic_url:
      "https://www.awesomecuisine.com/wp-content/uploads/2020/03/poori-masala-kizhangu-480x270.jpg",
    inventory: 20,
    price: "30",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Upma Pesarattu",
    description: "",
    pic_url:
      "https://res.cloudinary.com/roundglass/image/upload/v1697469276/rg/collective/media/rg-food-in-upma-pesarattu-rakesh-raghunathan-may2022-001-16x9-1697469275094.jpg",
    inventory: 20,
    price: "40",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Ravva Dosa",
    description: "",
    pic_url: "https://i.pinimg.com/originals/80/9a/45/809a45da3b652b5a6c7da2fd70560493.jpg",
    inventory: 20,
    price: "30",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Masala Dosa",
    description: "",
    pic_url:
      "https://vismaifood.com/storage/app/uploads/public/8b4/19e/427/thumb__1200_0_0_0_auto.jpg",
    inventory: 40,
    price: "40",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Plain Dosa",
    description: "",
    pic_url:
      "https://t3.ftcdn.net/jpg/03/97/46/66/360_F_397466683_4U8hMaUgWdFPNc8KMKUQ4aH2qR1yG0sA.jpg",
    inventory: 20,
    price: "30",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Paper Plain Dosa",
    description: "",
    pic_url:
      "https://www.awesomecuisine.com/wp-content/uploads/2009/06/Plain-Dosa.jpg",
    inventory: 20,
    price: "60",
    tags: ["tiffins", "breakfast", "south-indian"],
  },
  {
    name: "Biryani",
    description: "",
    pic_url:
      "https://t3.ftcdn.net/jpg/06/11/78/04/360_F_611780462_opmWlrkDqD74ReP5wAJ8Hjm0OMSsdXP1.jpg",
    inventory: 20,
    price: "50",
    tags: [
      "lunch",
      "dinner",
      "south-indian",
      "biryani",
      "biriyanis",
      "biryanis",
    ],
  },
  {
    name: "Fried Rice",
    description: "",
    inventory: 20,
    pic_url:
      "https://www.gourmandize.com/uploads/media/chinese-fried-rice.jpg?1395070660",
    price: "50",
    tags: ["lunch", "dinner", "indo-chinese"],
  },
  {
    name: "Noodles",
    description: "",
    pic_url:
      "https://myfoodstory.com/wp-content/uploads/2021/02/Vegetable-Hakka-Noodles-Restaurant-Style-3.jpg",
    inventory: 20,
    price: "50",
    tags: ["lunch", "dinner", "indo-chinese"],
  },
  {
    name: "Schezwan Fried Rice",
    description: "",
    pic_url:
      "https://www.vegrecipesofindia.com/wp-content/uploads/2021/02/schezwan-fried-rice-recipe-3.jpg",
    inventory: 20,
    price: 60,
    tags: ["lunch", "dinner", "indo-chinese"],
  },
  {
    name: "Schezwan Noodles",
    description: "",
    pic_url:
      "https://img.freepik.com/premium-photo/schezwan-veg-noodles-popular-indochinese-dish-made-with-noodles-vegetables-schezwan-sauce-served-rustic-wooden-background-selective-focus_726363-1143.jpg",
    inventory: 20,
    price: "60",
    tags: ["lunch", "dinner", "indo-chinese"],
  },
  {
    name: "Gulab Jamun",
    description: "",
    pic_url:
      "https://images.getrecipekit.com/20221019105927-gulab-20jamun.jpg?aspect_ratio=16:9&quality=90&",
    inventory: 20,
    price: "30",
    tags: ["dessert", "north-indian", "south-indian", "desserts"],
  },
  {
    name: "Samosa",
    description: "",
    pic_url:
      "https://bawarchiindianrestaurant.com/wp-content/uploads/2020/07/vegetable-samosa-3-pcs.png",
    inventory: 20,
    price: "10",
    tags: ["snacks", "north-indian", "south-indian"],
  },
  {
    name: "Samosa Chat",
    description: "",
    pic_url:
      "https://i0.wp.com/www.geetascuisine.com/wp-content/uploads/2014/11/Samosa-Chaat_14.jpg?fit=640%2C427",
    inventory: 20,
    price: "20",
    tags: ["snacks", "north-indian", "south-indian"],
  },
  {
    name: "Pani Puri",
    description: "",
    pic_url:
      "https://t4.ftcdn.net/jpg/03/87/74/77/360_F_387747747_2y85KCz1ErBxYVOinG306u3MAZqYym0r.jpg",
    inventory: 20,
    price: "10",
    tags: ["snacks", "north-indian", "south-indian"],
  },
  {
    name: "Sandwich",
    description: "",
    pic_url:
      "https://thumbs.dreamstime.com/b/veg-grilled-sandwich-served-ketchup-isolated-over-rustic-wooden-background-selective-focus-224440470.jpg",
    inventory: 20,
    price: "30",
    tags: ["snacks", "north-indian", "south-indian"],
  },
  {
    name: "Punugulu",
    description: "",
    pic_url:
      "https://www.thaayarfoodproducts.com/cdn/shop/articles/punugulu_ce7afd58-bcf5-429f-a1fa-c34879c2f3bb.jpg?v=1668445433",
    inventory: 20,
    price: "30",
    tags: ["snacks", "north-indian", "south-indian"],
  },
  {
    name: "Jalebi",
    description: "",
    pic_url:
      "https://media.istockphoto.com/id/1159362325/photo/bread-pakora.jpg?s=612x612&w=0&k=20&c=93uILcInCMXroXgjEJYXNeUzWh5NASSrEnylAgW7hcs=",
    inventory: 20,
    price: "20",
    tags: ["dessert", "north-indian", "south-indian", "desserts"],
  },
  {
    name: "Bhel Puri",
    description: "",
    pic_url:
      "https://shwetainthekitchen.com/wp-content/uploads/2022/01/bhel-puri.jpg",
    inventory: 20,
    price: "20",
    tags: ["snacks", "north-indian", "south-indian"],
  },
  {
    name: "Muri Mixture",
    description: "",
    pic_url: "https://i.ytimg.com/vi/HCnPZmJyEHE/maxresdefault.jpg",
    inventory: 20,
    price: "20",
    tags: ["snacks", "north-indian", "south-indian"],
  },
  {
    name: "Paneer Butter Masala",
    description: "",
    pic_url:
      "https://www.ruchiskitchen.com/wp-content/uploads/2020/12/Paneer-butter-masala-recipe-3-500x375.jpg",
    inventory: 20,
    price: "50",
    tags: ["north-indian", "lunch", "dinner"],
  },
  {
    name: "Malai Kofta",
    description: "",
    pic_url:
      "https://carveyourcraving.com/wp-content/uploads/2021/09/Best-Malai-Kofta-recipe.jpg",
    inventory: 20,
    price: "50",
    tags: ["north-indian", "lunch", "dinner"],
  },
  {
    name: "Palak Paneer",
    description: "",
    pic_url:
      "https://t4.ftcdn.net/jpg/06/13/65/75/360_F_613657567_NiNPLoP5GB9cZfoom8lWUgZnN01UtXA0.jpg",
    inventory: 20,
    price: "50",
    tags: ["north-indian", "lunch", "dinner"],
  },
  {
    name: "Channa Masala",
    description: "",
    pic_url:
      "https://media.istockphoto.com/id/1182758935/photo/homemade-indian-chickpea-chana-masala.jpg?s=612x612&w=0&k=20&c=t9hk82loyPEu37eFnA8v-oKGscX4_ektoiwUsXVsegs=",
    inventory: 20,
    price: "50",
    tags: ["north-indian", "lunch", "dinner"],
  },
  {
    name: "Aloo Gobi",
    description: "",
    pic_url:
      "https://www.whiskaffair.com/wp-content/uploads/2019/09/Aloo-Gobi-1-3.jpg",
    inventory: 20,
    price: 50,
    tags: ["north-indian", "lunch", "dinner"],
  },
  {
    name: "Dal Tadka",
    description: "",
    pic_url:
      "https://t3.ftcdn.net/jpg/02/49/13/46/360_F_249134675_sn1RWCs0xY4DHNmtbbOjRp7HxLdViCXR.jpg",
    inventory: 20,
    price: "50",
    tags: ["north-indian", "lunch", "dinner", "curry", "curries"],
  },
  {
    name: "Butter Naan",
    description: "",
    pic_url: "https://foodess.com/wp-content/uploads/2023/02/Butter-Naan-3.jpg",
    inventory: 20,
    price: "20",
    tags: ["north-indian", "lunch", "dinner"],
  },
  {
    name: "Semiya Upma",
    description: "",
    pic_url:
      "https://www.indianveggiedelight.com/wp-content/uploads/2019/06/vermicelli-upma-recipe-featured.jpg",
    inventory: 20,
    price: "30",
    tags: ["south-indian", "tiffins", "breakfast"],
  },
  {
    name: "Tomato Dal",
    description: "",
    pic_url: "https://venkuskitchen.com/wp-content/uploads/2018/09/Dal.jpg",
    inventory: 20,
    price: "30",
    tags: ["south-indian", "lunch", "dinner", "curries", "curries"],
  },
  {
    name: "Sambar",
    description: "",
    pic_url:
      "https://www.cubesnjuliennes.com/wp-content/uploads/2021/01/South-Indian-Sambar-Recipe.jpg",
    inventory: 20,
    price: "30",
    tags: ["south-indian", "lunch", "dinner", "curry", "curries"],
  },
  {
    name: "Rasam",
    description: "",
    pic_url:
      "https://t3.ftcdn.net/jpg/05/84/34/12/360_F_584341235_VBEH6O8yrIKXd9STuFbzdXvrn59TO5dW.jpg",
    inventory: 20,
    price: "30",
    tags: ["south-indian", "lunch", "dinner", "curry", "curries"],
  },
  {
    name: "Gobi 65",
    description: "",
    pic_url:
      "https://static.toiimg.com/thumb/61129931.cms?width=1200&height=900",
    inventory: 20,
    price: "30",
    tags: ["south-indian", "lunch", "dinner", "curry", "curries"],
  },
  {
    name: "Aloo Fry",
    description: "",
    pic_url:
      "https://www.sailusfood.com/wp-content/uploads/2016/03/how-to-make-potato-fry.jpg",
    inventory: 20,
    price: "30",
    tags: ["south-indian", "lunch", "dinner", "curry", "curries"],
  },
  {
    name: "Dondakaya Fry",
    description: "",
    inventory: 20,
    pic_url:
      "https://myheartbeets.com/wp-content/uploads/2022/04/Tindora-sabzi.jpg",
    price: "30",
    tags: ["south-indian", "lunch", "dinner", "curry", "curries"],
  },
  {
    name: "Paneer Biryani",
    description: "",
    pic_url:
      "https://t4.ftcdn.net/jpg/06/56/09/67/360_F_656096784_ASjRCLPI2M0BQzOFpXnkrBdkqTQFIv8K.jpg",
    inventory: 20,
    price: "60",
    tags: ["south-indian", "lunch", "dinner", "biryani", "biryanis"],
  },
  {
    name: "Brinjal Biryani",
    description: "",
    pic_url:
      "https://assets.bonappetit.com/photos/61afad39d0b93410e18acd94/1:1/w_1482,h_1482,c_limit/20211123%20Eggplant%20Biryani%20LEDE.jpg",
    inventory: 20,
    price: "60",
    tags: ["south-indian", "lunch", "dinner", "biryani", "biryanis"],
  },
  {
    name: "Shahi Pulao",
    description: "",
    pic_url:
      "https://www.funfoodfrolic.com/wp-content/uploads/2022/05/Veg-Pulao-Blog.jpg",
    inventory: 20,
    price: "50",
    tags: ["north-indian", "lunch", "dinner", "pulao", "biryanis", "biryani"],
  },
  {
    name: "Tawa Pulao",
    description: "",
    pic_url:
      "https://www.jcookingodyssey.com/wp-content/uploads/2012/03/tawa-pulao-recipe-j-cooking-odyssey-1.jpg",
    inventory: 20,
    price: "30",
    tags: ["north-indian", "lunch", "dinner", "pulao", "biryani", "biryanis"],
  },
  {
    name: "Bismilla Bath",
    description: "",
    pic_url:
      "https://www.currytrail.in/wp-content/uploads/2017/01/IMG_6945-2.jpg",
    inventory: 20,
    price: "50",
    tags: ["south-indian", "lunch", "dinner"],
  },
  {
    name: "Sambar Sadam",
    description: "",
    pic_url:
      "https://static.toiimg.com/thumb/60781217.cms?imgsize=230260&width=800&height=800",
    inventory: 20,
    price: "50",
    tags: ["south-indian", "lunch", "dinner"],
  },
  {
    name: "French Fries",
    description: "",
    pic_url:
      "https://www.recipetineats.com/wp-content/uploads/2022/09/Fries-with-rosemary-salt_1.jpg",
    inventory: 100,
    price: "30",
    tags: ["foreign", "snacks"],
  },
  {
    name: "Smileys",
    description: "",
    pic_url:
      "https://lovefoodnotcooking.com/wp-content/uploads/2021/03/air-fryer-smiley-fries_l-720x720.jpg",
    inventory: 100,
    price: "30",
    tags: ["foreign", "snacks"],
  },
  {
    name: "Burger",
    description: "",
    pic_url:
      "https://www.noracooks.com/wp-content/uploads/2023/04/veggie-burgers-1-2.jpg",
    inventory: 100,
    price: 50,
    tags: ["foreign", "snacks"],
  },
  {
    name: "Cheese pizza",
    description: "",
    pic_url:
      "https://againstthegraingourmet.com/cdn/shop/products/ThreeCheese_Pizza_Beauty_d3eeea98-1706-4092-8171-60738ac55937_1000x1000.jpg?v=1658703750",
    inventory: 100,
    price: "70",
    tags: ["foreign", "snacks"],
  },
  {
    name: "Papad",
    description: "",
    pic_url:
      "https://static.toiimg.com/thumb/55433327.cms?width=1200&height=900",
    inventory: 100,
    price: "10",
    tags: ["south_indian", "north-indian", "snacks", "sides"],
  },
  {
    name: "Chum chum",
    description: "",
    pic_url:
      "https://www.shutterstock.com/image-photo/fresh-tasty-chum-600nw-36536251.jpg",
    inventory: 100,
    price: "30",
    tags: ["dessert", "desserts"],
  },
  {
    name: "Manchuria",
    description: "",
    pic_url:
      "https://vegecravings.com/wp-content/uploads/2017/03/veg-manchurian-dry-recipe-step-by-step-instructions-10.jpg",
    inventory: 100,
    price: 50,
    tags: ["snacks", "indo-chinese"],
  },
  {
    name: "Manchuria Wet",
    description: "",
    pic_url:
      "https://myfoodstory.com/wp-content/uploads/2021/10/Veg-Manchurian-2.jpg",
    inventory: 100,
    price: 50,
    tags: ["indo-chinese", "snacks"],
  },
  {
    name: "Gobi Manchuria",
    description: "",
    pic_url:
      "https://rainbowplantlife.com/wp-content/uploads/2022/02/Gobi-Manchurian-cover-photo-on-white-tile-1-of-1.jpg",
    inventory: 100,
    price: 50,
    tags: ["indo-chinese", "snacks"],
  },
  {
    name: "Tomato Soup",
    description: "",
    pic_url:
      "https://www.gimmesomeoven.com/wp-content/uploads/2021/09/Roasted-Tomato-Soup-Recipe-8.jpg",
    inventory: 100,
    price: "40",
    tags: ["soup", "north-indian", "soups"],
  },
  {
    name: "Manchow Soup",
    description: "",
    inventory: 100,
    pic_url:
      "https://www.archanaskitchen.com/images/archanaskitchen/World_Asian/Vegetable_Manchow_Soup.jpg",
    price: 50,
    tags: ["soup", "north-indian", "soups"],
  },
  {
    name: "Hot N Sour Soup",
    description: "",
    pic_url:
      "https://smithakalluraya.com/wp-content/uploads/2023/01/hot-and-sour-soup.jpg",
    inventory: 100,
    price: "40",
    tags: ["soup", "north-indian", "soups"],
  },
  {
    name: "Corn Soup",
    description: "",
    pic_url:
      "https://www.acouplecooks.com/wp-content/uploads/2020/08/Corn-Soup-005.jpg",
    inventory: 100,
    price: "40",
    tags: ["soup", "north-indian", "soups"],
  },
  {
    name: "Spinach Dal",
    description: "",
    pic_url:
      "https://www.indianveggiedelight.com/wp-content/uploads/2017/05/palak-dal-stovetop-featured.jpg",
    inventory: 100,
    price: 50,
    tags: [
      "curry",
      "south-indian",
      "lunch",
      "dinner",
      "curries",
      "curries",
      "curries",
    ],
  },
  {
    name: "Rice",
    description: "",
    pic_url:
      "https://assets.epicurious.com/photos/568eb0bf7dc604b44b5355ee/16:9/w_2560%2Cc_limit/rice.jpg",
    inventory: 100,
    price: "20",
    tags: ["south-indian", "lunch", "dinner"],
  },
  {
    name: "Mysore Pak",
    description: "",
    pic_url:
      "https://static.toiimg.com/thumb/53376135.cms?imgsize=204335&width=800&height=800",
    inventory: 100,
    price: "40",
    tags: ["dessert", "desserts"],
  },
  {
    name: "Payasam",
    description: "",
    pic_url:
      "https://thumbs.dreamstime.com/b/semiya-payasam-shewai-sewai-khir-seviyan-kheer-indian-sweet-made-vermicelli-milk-ghee-sugar-jaggery-raisins-302152635.jpg",
    inventory: 100,
    price: 50,
    tags: ["dessert", "desserts"],
  },
  {
    name: "Carrot Halwa",
    description: "",
    pic_url:
      "https://www.cookingcarnival.com/wp-content/uploads/2014/11/Gajar-halwa-3.jpg",
    inventory: 100,
    price: "40",
    tags: ["dessert", "desserts"],
  },
  {
    name: "Mango Pickle",
    description: "",
    pic_url:
      "https://www.sailusfood.com/wp-content/uploads/2015/05/mango-pickle.jpg",
    inventory: 100,
    price: 50,
    tags: ["pickle", "south-indian", "sides"],
  },
  {
    name: "Puff",
    description: "",
    pic_url:
      "https://www.cookwithmanali.com/wp-content/uploads/2021/05/Veg-Puff-500x500.jpg",
    inventory: 100,
    price: "40",
    tags: ["snacks", "foreign"],
  },
  {
    name: "Croissant",
    description: "",
    pic_url:
      "https://www.delscookingtwist.com/wp-content/uploads/2020/04/Caprese-Croissant-Breakfast-Sandwich_1.jpg",
    inventory: 100,
    price: "50",
    tags: ["foreign", "snacks"],
  },
  {
    name: "Fruit Salad",
    description: "",
    pic_url:
      "https://feelgoodfoodie.net/wp-content/uploads/2017/10/Fresh-Fruit-Salad-06.jpg",
    inventory: 100,
    price: 50,
    tags: ["sides", "snacks"],
  },
  {
    name: "Panasa Biryani",
    description: "",
    pic_url:
      "https://i.ytimg.com/vi/SdrjPty28HM/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLD5hto7bfZOVJr-E2GhncbromNqPw",
    inventory: 100,
    price: 50,
    tags: [
      "biryani",
      "south-indian",
      "lunch",
      "dinner",
      "biriyanis",
      "biryanis",
    ],
  },
  {
    name: "Pongal",
    description: "",
    pic_url: "https://moonrice.net/wp-content/uploads/2022/01/Pongal-2.jpg",
    inventory: 100,
    price: 50,
    tags: ["tiffin", "sides"],
  },
  {
    name: "Laddu",
    description: "",
    pic_url:
      "https://s.yimg.com/uu/api/res/1.2/QQaTEU2Cj1nINNgwKlmjag--~B/aD04MDA7dz01MzQ7YXBwaWQ9eXRhY2h5b24-/http://65.media.tumblr.com/7b4aa9965878629dd3ad4a07f27fcde4/tumblr_inline_o7sfyp4q361u4ho4i_540.jpg",
    inventory: 100,
    price: 50,
    tags: ["dessert", "desserts"],
  },
  {
    name: "Boondi Laddu",
    description: "",
    pic_url:
      "https://cookingfromheart.com/wp-content/uploads/2019/10/Boondi-Laddu-1.jpg",
    inventory: 100,
    price: 50,
    tags: ["dessert", "desserts"],
  },
  {
    name: "Kaja",
    description: "",
    pic_url:
      "https://cloudinary-cdn.whisk.com/image/upload/g_auto,c_fill,q_60,f_auto,h_630,w_1200/v1605562932/recipe/38ee8d70755823d7dff360693d631d16.jpg",
    inventory: 100,
    price: "40",
    tags: ["dessert", "desserts"],
  },
  {
    name: "Pulihora",
    description: "",
    pic_url:
      "https://www.cookshideout.com/wp-content/uploads/2015/03/Tomato-Pulihora-FI.jpg",
    inventory: 100,
    price: 50,
    tags: ["lunch", "dinner", "south-indian"],
  },
  {
    name: "Pulihora Paste",
    description: "",
    pic_url:
      "https://www.fiahomefoods.com/uploads/products/Chintapandu-Pulihora-mix-fia_1687189889.jpg",
    inventory: 100,
    price: "30",
    tags: ["sides", "side"],
  },
  {
    name: "Maggi",
    description: "",
    pic_url:
      "https://vegecravings.com/wp-content/uploads/2020/01/Vegetable-Masala-Maggi-Recipe-Step-By-Step-Instructions-1024x900.jpg.webp",
    inventory: 100,
    price: "40",
    tags: ["snacks"],
  },
  {
    name: "Channa Batura",
    description: "",
    pic_url:
      "https://i1.wp.com/chaitrascreations.com/wp-content/uploads/2020/05/IMG_7140-scaled.jpeg?fit=800%2C631&ssl=1",
    inventory: 100,
    price: 50,
    tags: ["north-indian", "lunch", "dinner"],
  },
  {
    name: "Pulka",
    description: "",
    pic_url:
      "https://thepulka.files.wordpress.com/2018/03/phulka-at-home.jpg?w=679&h=438",
    inventory: 100,
    price: "20",
    tags: ["north-indian", "lunch", "dinner", "sides"],
  },
  {
    name: "Parota",
    description: "",
    pic_url: "https://farm9.staticflickr.com/8586/16023214373_90552b64f6_o.jpg",
    inventory: 100,
    price: "40",
    tags: ["north-indian", "lunch", "dinner", "sides"],
  },
  {
    name: "Okra Fry",
    description: "",
    pic_url:
      "https://www.vegrecipesofindia.com/wp-content/uploads/2015/12/bendakaya-fry-recipe-1.jpg",
    inventory: 100,
    price: "30",
    tags: ["south-indian", "lunch", "dinner", "curry", "curries"],
  },
  {
    name: "Mirchi Bajji",
    description: "",
    pic_url: "https://farm9.staticflickr.com/8669/16110675524_38a8346df1_o.jpg",
    inventory: 100,
    price: "30",
    tags: ["south-indian", "snacks", "sides"],
  },
  {
    name: "Metha Pakodi",
    description: "",
    pic_url: "https://i.ytimg.com/vi/_90cYZEcA8U/maxresdefault.jpg",
    inventory: 100,
    price: "30",
    tags: ["south-indian", "snacks", "sides"],
  },
  {
    name: "Gatti Pakodi",
    description: "",
    pic_url:
      "https://www.telugufoodrecipes.com/resources/picture/org/Gatti-pakodi.jpg",
    inventory: 100,
    price: "30",
    tags: ["south-indian", "snacks", "sides"],
  },
  {
    name: "Ugadi Chutney",
    description: "",
    pic_url:
      "https://veenasvegnation.com/wp-content/uploads/2017/04/ugadi-pachadi-1.jpg",
    inventory: 100,
    price: "50",
    tags: ["south-indian", "sides"],
  },
  {
    name: "Spring Roll",
    description: "",
    pic_url:
      "https://myfoodstory.com/wp-content/uploads/2022/06/Veg-Spring-Rolls-3.jpg",
    inventory: 100,
    price: 50,
    tags: ["indo-chinese", "sides", "snacks"],
  },
  {
    name: "Babycorn Manchuria",
    description: "",
    pic_url:
      "https://cdn2.foodviva.com/static-content/food-images/chinese-recipes/baby-corn-manchurian/baby-corn-manchurian.jpg",
    inventory: 100,
    price: 50,
    tags: ["indo-chinese", "snacks", "sides"],
  },
  {
    name: "Crispy Corn",
    description: "",
    pic_url:
      "https://static.toiimg.com/thumb/93714345.cms?imgsize=72836&width=800&height=800",
    inventory: 100,
    price: "40",
    tags: ["snacks", "sides"],
  },
  {
    name: "Sweet Boondi",
    description: "",
    pic_url:
      "https://static.toiimg.com/thumb/58417488.cms?imgsize=97128&width=800&height=800",
    inventory: 100,
    price: 50,
    tags: ["dessert", "desserts"],
  },
  {
    name: "Kalakanda",
    description: "",
    pic_url:
      "https://pushmycart.com/cdn/shop/products/347199062_3.jpg?v=1628122027",
    inventory: 100,
    price: 50,
    tags: ["dessert", "desserts"],
  },
  {
    name: "Charu",
    description: "",
    inventory: 100,
    pic_url:
      "https://vismaifood.com/storage/app/uploads/public/edc/d9e/a85/thumb__700_0_0_0_auto.jpg",
    price: "40",
    tags: ["south-indian", "curry", "lunch", "dinner", "curries"],
  },
  {
    name: "Choco Cake",
    description: "",
    pic_url:
      "https://sugargeekshow.com/wp-content/uploads/2023/10/easy_chocolate_cake_slice.jpg",
    inventory: 100,
    price: 50,
    tags: ["dessert", "desserts"],
  },
  {
    name: "Vanilla Cake",
    description: "",
    pic_url:
      "https://www.recipetineats.com/wp-content/uploads/2020/08/My-best-Vanilla-Cake_9-SQ.jpg",
    inventory: 100,
    price: 50,
    tags: ["dessert", "desserts"],
  },
  {
    name: "Strawberry Cake",
    description: "",
    pic_url:
      "https://sugargeekshow.com/wp-content/uploads/2019/07/fresh-strawberry-cake-5-500x375.jpg",
    inventory: 100,
    price: 50,
    tags: ["dessert", "desserts"],
  },
  {
    name: "Dahi Vada",
    description: "",
    pic_url:
      "https://static.toiimg.com/thumb/55432577.cms?imgsize=240828&width=800&height=800",
    inventory: 100,
    price: "40",
    tags: ["tiffin", "sides", "snacks", "north-indian", "south-indian"],
  },
  {
    name: "Navratan Kurma",
    description: "",
    pic_url:
      "https://www.awesomecuisine.com/wp-content/uploads/2007/10/Navratan-Korma.jpg",
    inventory: 100,
    price: 50,
    tags: ["north-indian", "lunch", "dinner"],
  },
  {
    name: "Dibba Rotti",
    description: "",
    pic_url:
      "https://www.cookshideout.com/wp-content/uploads/2006/12/Dibba-Rotti-FI.jpg",
    inventory: 100,
    price: 50,
    tags: ["tiffin", "breakfast", "south-indian"],
  },
  {
    name: "Tomato Bath",
    description: "",
    pic_url:
      "https://smithakalluraya.com/wp-content/uploads/2022/09/tomato-upma-recipe-500x500.jpg",
    inventory: 100,
    price: 50,
    tags: ["tiffin", "breakfast", "south-indian"],
  },
]